module.exports = __webpack_public_path__ + "static/img/img1.752fe17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity618/img1.png
// module id = H3hV
// module chunks = 0